import { SET_CUSTOM_FIELDS } from './customField.action';

const initialState = {
  fields: [],
};

const customFieldReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOM_FIELDS:
      return {
        ...state,
        fields: action.payload,
      };
    default:
      return state;
  }
};

export default customFieldReducer;
